import PropTypes from 'prop-types';

import styles from './styles';
import SelectDropdown from '../../ComponentLibrary/input-elements/oc-select-dropdown';
import Text from '../../OC/oc-text';
import { connectLocation } from '../../location/LocationConnectors';

const SortByBase = ({ sort = 'latest', setSort, t }) => {
  const options = [
    { value: 'latest', text: t('bazaarvoice.sort_latest') },
    { value: 'highest', text: t('bazaarvoice.sort_highest') },
    { value: 'lowest', text: t('bazaarvoice.sort_lowest') },
  ];

  return (
    <div css={styles} data-testid="bazaarvoice-sort-by">
      <p className="sort-by__label">
        <Text content={t('bazaarvoice.sort_by')} />
      </p>
      <SelectDropdown value={sort} onChange={e => setSort(e.target.value)} options={options} />
    </div>
  );
};

SortByBase.propTypes = {
  // eslint-disable-next-line react/require-default-props
  sort: PropTypes.string,
  setSort: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export const SortBy = connectLocation(SortByBase);
